import React from "react";
import Loadable from "../../../react-loadable";

const Com = Loadable({
  loader: () => import("./Main"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default Com;



// WEBPACK FOOTER //
// ./ecology9/base/wea-textarea-normal/index.js